import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-type": "application/json"
  }
});

// Fonction pour configurer le token d'authentification
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

export default api;